import { IOfferHistoryData, TStatusFiltersActiveIDs, TRoomsFiltersActiveIDs } from '../types';

export enum EActionTypes {
  request = 'offer-history/request',
  success = 'offer-history/success',
  successLoadMore = 'offer-history/success-load-more',
  failure = 'offer-history/failure',
  setPage = 'offer-history/set-page',
  setRoomsFilter = 'offer-history/set-rooms-filter',
  setStatusFilter = 'offer-history/set-status-filter',
}

interface ITypedReduxAction<Type, Payload = void> {
  type: Type;
  payload: Payload;
}

export type TOfferHistoryActions =
  | ITypedReduxAction<EActionTypes.request>
  | ITypedReduxAction<EActionTypes.success, IOfferHistoryData>
  | ITypedReduxAction<EActionTypes.successLoadMore, IOfferHistoryData>
  | ITypedReduxAction<EActionTypes.failure>
  | ITypedReduxAction<EActionTypes.setPage, number>
  | ITypedReduxAction<EActionTypes.setRoomsFilter, TRoomsFiltersActiveIDs | null>
  | ITypedReduxAction<EActionTypes.setStatusFilter, TStatusFiltersActiveIDs | null>;
